(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-featured-drop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* The CTA reveals the real packs configurator, which lives in its own
       section below. Two sections rather than one because Liquid cannot nest
       them, and a second copy of the buy box inside this one would be a
       lookalike that drifts from the product page the first time either
       changes. Same section, same script, same behaviour, guaranteed. */
    const boot = (root) => {
      if (root.dataset.ready === '1') return;
      root.dataset.ready = '1';
      const toggle = root.querySelector('[data-o-drop-toggle]');
      if (!toggle) return;

      const target = () => document.querySelector('[data-o-drop-target]');
      const tierRow = root.querySelector('.o-drop__tiers');

      const reveal = (size) => {
        const host = target();
        if (!host) return false;
        host.hidden = false;
        /* max-height cannot animate to auto, so measure the opened height and
           hand it to the keyframes as a custom property. */
        host.style.setProperty('--o-embed-h', host.scrollHeight + 'px');
        host.classList.remove('is-open');
        void host.offsetWidth;               // restart the animation on reopen
        host.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        /* The configurator carries its own tier tiles, so the summary row
           above would otherwise show the same three sizes twice. */
        if (tierRow) tierRow.hidden = true;
        if (size) {
          /* Hand the chosen size to the configurator by clicking its own tier
             tile, so the buy box stays the single source of its own state. */
          const tiles = host.querySelectorAll('.o-buy__tier');
          tiles.forEach((t) => {
            const n = (t.querySelector('.o-buy__tier-qty') || {}).textContent || '';
            if (n.trim() === String(size).trim()) t.click();
          });
        }
        host.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      };

      const collapse = () => {
        const host = target();
        if (!host) return;
        host.hidden = true;
        host.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (tierRow) tierRow.hidden = false;
        toggle.scrollIntoView({ behavior: 'smooth', block: 'center' });
        toggle.focus({ preventScroll: true });
      };

      toggle.addEventListener('click', (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        const host = target();
        if (!host) return;              // no configurator on this page: follow the link
        e.preventDefault();
        if (host.hidden) reveal(null);
        else collapse();
      });

      /* Escape closes it, as it would any expanded panel, unless the focus is
         inside a field where Escape means something else. */
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const host = target();
        if (!host || host.hidden) return;
        const tag = (document.activeElement || {}).tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
        collapse();
      });

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-o-drop-close]')) collapse();
      });

      root.querySelectorAll('.o-drop__tier').forEach((tile) => {
        tile.addEventListener('click', (e) => {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
          if (!target()) return;
          e.preventDefault();
          const n = (tile.querySelector('.o-drop__tier-n') || {}).textContent || '';
          reveal(n);
        });
      });
    };
    const run = () => document.querySelectorAll('.o-drop').forEach(boot);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orion-recipe-portal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = (root) => {
      if (root.dataset.ready === '1') return;
      root.dataset.ready = '1';
      const grid = root.querySelector('[data-o-vault-grid]');
      const empty = root.querySelector('[data-o-vault-empty]');
      if (!grid) return;

      root.querySelectorAll('[data-o-filter]').forEach((chip) => {
        chip.addEventListener('click', () => {
          root.querySelectorAll('[data-o-filter]').forEach((c) => c.classList.toggle('is-on', c === chip));
          const want = chip.dataset.oFilter;
          let shown = 0;
          grid.querySelectorAll('.o-vault__card').forEach((card) => {
            const ok = want === 'all' || card.dataset.flavour === want;
            card.hidden = !ok;
            if (ok) shown += 1;
          });
          if (empty) empty.hidden = shown > 0;
        });
      });

      /* Accordion rather than links: 25 recipes as separate pages would be 25
         round trips on a phone in a kitchen. */
      grid.querySelectorAll('.o-vault__card-head').forEach((head) => {
        head.addEventListener('click', () => {
          const body = head.nextElementSibling;
          if (!body) return;
          const open = !body.hidden;
          body.hidden = open;
          head.setAttribute('aria-expanded', String(!open));
        });
      });
    };
    const run = () => document.querySelectorAll('[data-o-vault]').forEach(boot);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
